import { Props } from './types';
import { StyledText } from './styled';

const Typography = ({
  as,
  children,
  color = 'darkGrey',
  variant,
  weight = 'Regular',
  ...rest
}: Props<typeof as>) => {
  const Component = as || 'span';

  return (
    <StyledText
      variant={variant}
      weight={weight}
      color={color}
      as={Component}
      {...rest}
    >
      {children}
    </StyledText>
  );
};

export default Typography;
